import React from 'react';

const PMProgress = ({ value = 0, className = '', ...props }) => {
  // Ensure value is between 0 and 100
  const normalizedValue = Math.min(Math.max(parseFloat(value) || 0, 0), 100);

  const getProgressBackgroundColor = (percentage) => {
    if (percentage >= 80) return 'bg-emerald-500 text-white dark:bg-emerald-600';
    if (percentage >= 60) return 'bg-blue-500 text-white dark:bg-blue-600';
    if (percentage >= 40) return 'bg-amber-500 text-white dark:bg-amber-600';
    if (percentage >= 20) return 'bg-orange-200 text-white dark:bg-orange-600';
    return 'bg-gray-500 text-white dark:bg-gray-600';
  };

  return (
    <span className={`pm-progress-badge inline-flex items-center px-2 py-1 text-xs font-medium rounded-md ml-1 ${getProgressBackgroundColor(normalizedValue)} ${className}`} {...props}>
      {normalizedValue.toFixed(0)}%
    </span>
  );
};

export default PMProgress; 